"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_measure_1 = tslib_1.__importDefault(require("react-measure"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var geoChartColor_1 = require("./geoChartColor");
var PushpinCategoryLegend_1 = tslib_1.__importStar(require("./legends/PushpinCategoryLegend"));
var PushpinSizeLegend_1 = tslib_1.__importDefault(require("./legends/PushpinSizeLegend"));
var data_1 = require("./helpers/geoChart/data");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var responsive_1 = require("./helpers/geoChart/responsive");
var HEIGHT_OF_COLOR_LEGEND = 210;
function getClassnames(props, availableLegends) {
    var _a;
    var position = props.position, isFluidLegend = props.isFluidLegend;
    var hasSizeLegend = availableLegends.hasSizeLegend;
    var isBottomPosition = isFluidLegend || position === "bottom";
    return classnames_1["default"]("geo-legend", "s-geo-legend", "viz-legend", (_a = {
            "viz-fluid-legend-wrap": isFluidLegend,
            "viz-static-legend-wrap": !isFluidLegend,
            static: !isFluidLegend,
            "has-size-legend": hasSizeLegend
        },
        _a["position-" + position] = !isBottomPosition,
        // this is required in case
        // position is not BOTTOM but isFluidLegend is true
        _a["position-bottom"] = isBottomPosition,
        _a));
}
function GeoChartLegendRenderer(props) {
    var _a;
    var _b = props.categoryItems, categoryItems = _b === void 0 ? [] : _b, _c = props.geoData, geoData = _c === void 0 ? {} : _c, height = props.height, _d = props.numericSymbols, numericSymbols = _d === void 0 ? [] : _d;
    var position = (_a = props.position) !== null && _a !== void 0 ? _a : "top";
    var availableLegends = data_1.getAvailableLegends(categoryItems, geoData);
    var hasCategoryLegend = availableLegends.hasCategoryLegend, hasColorLegend = availableLegends.hasColorLegend, hasSizeLegend = availableLegends.hasSizeLegend;
    var isLegendVisible = hasCategoryLegend || hasColorLegend || hasSizeLegend;
    if (!isLegendVisible) {
        return null;
    }
    if (hasCategoryLegend) {
        return renderCategoryAndSizeLegend(props, availableLegends);
    }
    if (hasColorLegend && hasSizeLegend && shouldShowPagingLegend(height, position)) {
        return (react_1["default"].createElement(ColorAndSizeLegendWithPaging, tslib_1.__assign({}, props, { numericSymbols: numericSymbols, availableLegends: availableLegends })));
    }
    return renderColorAndSizeLegend(props, availableLegends);
}
exports["default"] = GeoChartLegendRenderer;
function renderCategoryAndSizeLegend(props, availableLegends) {
    var contentRect = props.contentRect, renderPopUp = props.renderPopUp;
    var hasSizeLegend = availableLegends.hasSizeLegend;
    var classNames = classnames_1["default"](getClassnames(props, availableLegends));
    return (react_1["default"].createElement(react_measure_1["default"], { client: true }, function (_a) {
        var _b;
        var measureRef = _a.measureRef, contentRectLegend = _a.contentRect;
        if (responsive_1.shouldRenderCircleLegendInsidePopUp((_b = contentRect === null || contentRect === void 0 ? void 0 : contentRect.client) === null || _b === void 0 ? void 0 : _b.width, renderPopUp)) {
            return (react_1["default"].createElement("div", { className: classNames, ref: measureRef }, renderPushpinLegend(props, contentRectLegend, hasSizeLegend)));
        }
        return (react_1["default"].createElement("div", { className: classNames, ref: measureRef },
            renderPushpinCategoryLegend(props, contentRectLegend, hasSizeLegend),
            renderPushpinSizeLegend(props, hasSizeLegend)));
    }));
}
// if height of color + size is bigger than container, we will show paging for legends
function shouldShowPagingLegend(height, legendPosition) {
    if (height !== undefined && (legendPosition === "left" || legendPosition === "right")) {
        var heightOfColorAndSizeLegend = HEIGHT_OF_COLOR_LEGEND + PushpinCategoryLegend_1.HEIGHT_OF_SIZE_LEGEND;
        return height < heightOfColorAndSizeLegend;
    }
    return false;
}
function ColorAndSizeLegendWithPaging(props) {
    var _a = react_1["default"].useState(1), page = _a[0], setPage = _a[1];
    var showNextPage = function () { return setPage(2); };
    var showPrevPage = function () { return setPage(1); };
    var availableLegends = props.availableLegends;
    var classNames = getClassnames(props, availableLegends);
    return (react_1["default"].createElement("div", { className: classNames },
        react_1["default"].createElement("div", { className: "geo-legend-paging" },
            renderPushpinColorLegend(props, page === 1),
            renderPushpinSizeLegend(props, page === 2)),
        react_1["default"].createElement(sdk_ui_vis_commons_1.Paging, { page: page, pagesCount: 2, showNextPage: showNextPage, showPrevPage: showPrevPage })));
}
function renderColorAndSizeLegend(props, availableLegends) {
    var hasColorLegend = availableLegends.hasColorLegend, hasSizeLegend = availableLegends.hasSizeLegend;
    var classNames = getClassnames(props, availableLegends);
    return (react_1["default"].createElement("div", { className: classNames },
        renderPushpinColorLegend(props, hasColorLegend),
        renderPushpinSizeLegend(props, hasSizeLegend)));
}
function renderPushpinColorLegend(props, hasColorLegend) {
    var _a, _b;
    if (!hasColorLegend) {
        return null;
    }
    var geoData = props.geoData, _c = props.position, position = _c === void 0 ? "top" : _c, responsive = props.responsive, isFluidLegend = props.isFluidLegend, colorLegendValue = props.colorLegendValue, _d = props.numericSymbols, numericSymbols = _d === void 0 ? [] : _d, contentRect = props.contentRect;
    var data = geoData.color.data;
    var format = geoData.color.format;
    var dataWithoutNull = data.filter(isFinite);
    var colorData = geoChartColor_1.generateLegendColorData(dataWithoutNull, colorLegendValue);
    var width = (_a = contentRect === null || contentRect === void 0 ? void 0 : contentRect.client) === null || _a === void 0 ? void 0 : _a.width;
    var size = responsive_1.getPushpinColorLegendSize(width, isFluidLegend, responsive);
    var title = responsive_1.getPushpinColorLegendTitle((_b = geoData === null || geoData === void 0 ? void 0 : geoData.color) === null || _b === void 0 ? void 0 : _b.name, width, responsive);
    return (react_1["default"].createElement(sdk_ui_vis_commons_1.ColorLegend, { data: colorData, format: format, size: size, numericSymbols: numericSymbols, position: position, title: title }));
}
function renderPushpinCategoryLegend(props, contentRect, hasSizeLegend) {
    var containerId = props.containerId;
    if (!containerId) {
        return null;
    }
    return (react_1["default"].createElement(PushpinCategoryLegend_1["default"], tslib_1.__assign({}, props, { contentRect: contentRect, hasSizeLegend: hasSizeLegend, containerId: containerId })));
}
function renderPushpinSizeLegend(props, hasSizeLegend, ignoreMeasureName, ignoreSmallSize) {
    var _a;
    if (ignoreMeasureName === void 0) { ignoreMeasureName = false; }
    if (ignoreSmallSize === void 0) { ignoreSmallSize = false; }
    if (!hasSizeLegend) {
        return null;
    }
    var geoData = props.geoData, _b = props.numericSymbols, numericSymbols = _b === void 0 ? [] : _b, responsive = props.responsive, contentRect = props.contentRect;
    if (!(geoData === null || geoData === void 0 ? void 0 : geoData.size)) {
        return null;
    }
    var _c = geoData.size, data = _c.data, format = _c.format, name = _c.name;
    var width = (_a = contentRect === null || contentRect === void 0 ? void 0 : contentRect.client) === null || _a === void 0 ? void 0 : _a.width;
    var isSmall = responsive_1.isSmallPushpinSizeLegend(width, ignoreSmallSize, responsive);
    var title = responsive_1.getPushpinSizeLegendTitle(name, width, ignoreMeasureName);
    var showMiddleCircle = responsive_1.shouldRenderMiddleCircle(width, ignoreSmallSize);
    return (react_1["default"].createElement(PushpinSizeLegend_1["default"], { format: format, measureName: title, numericSymbols: numericSymbols, sizes: data, isSmall: isSmall, showMiddleCircle: showMiddleCircle }));
}
function renderPushpinLegend(props, contentRect, hasSizeLegend) {
    var _a, _b;
    var containerId = props.containerId;
    if (!containerId) {
        return null;
    }
    return (react_1["default"].createElement(PushpinCategoryLegend_1["default"], tslib_1.__assign({}, props, { contentRect: contentRect, hasSizeLegend: hasSizeLegend, isSizeLegendVisible: false, containerId: containerId, customComponent: renderPushpinSizeLegend(props, hasSizeLegend, true, true), customComponentName: (_b = (_a = props.geoData) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.name })));
}
//# sourceMappingURL=GeoChartLegendRenderer.js.map